import {styled, Box} from '@mui/material';

export const StyledBox = styled(Box)`
	margin-top: auto;
	${({theme}) => theme.breakpoints.down('sm')} {
		margin-bottom: 56px;
	}
`;
